import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { alchemy } from "../utils/alchemy";

function AddressDetails() {
  const { address } = useParams();
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchAddressInfo() {
      try {
        const balanceData = await alchemy.core.getBalance(address);
        setBalance(balanceData);

        const history = await alchemy.core.getAssetTransfers({
          fromAddress: address,
          category: ["external", "internal", "erc20", "erc721", "erc1155"],
          maxCount: 20,
        });

        setTransactions(history.transfers);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching address info:", error);
        setLoading(false);
      }
    }

    fetchAddressInfo();
  }, [address]);

  if (loading) {
    return <div className="loading">Loading address details...</div>;
  }

  return (
    <div className="page">
      <h1>Address Details</h1>

      <div className="details-grid">
        <div className="detail-item full-width">
          <div className="label">Address</div>
          <div className="value mono">{address}</div>
        </div>

        <div className="detail-item">
          <div className="label">Balance</div>
          <div className="value">
            {(parseInt(balance._hex, 16) / 1e18).toFixed(6)} ETH
          </div>
        </div>
      </div>

      <h2>Recent Transactions</h2>
      <div className="transactions-list">
        {transactions.length === 0 ? (
          <p>No recent transactions found</p>
        ) : (
          transactions.map((tx, index) => (
            <div key={index} className="transaction-card">
              <Link to={`/tx/${tx.hash}`} className="tx-hash">
                {tx.hash || "N/A"}
              </Link>
              <div className="tx-meta">
                <span>From: {tx.from || "N/A"}</span>
                <span>To: {tx.to || "N/A"}</span>
                <span>
                  Value: {tx.value ? tx.value.toFixed(4) : "0"}{" "}
                  {tx.asset || "ETH"}
                </span>
                <span>
                  Block: <Link to={`/block/${tx.blockNum}`}>{tx.blockNum}</Link>
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default AddressDetails;
